import { render, staticRenderFns } from "./ModalPolicy.vue?vue&type=template&id=2b41009e&scoped=true&"
import script from "./ModalPolicy.vue?vue&type=script&lang=js&"
export * from "./ModalPolicy.vue?vue&type=script&lang=js&"
import style0 from "./ModalPolicy.vue?vue&type=style&index=0&id=2b41009e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b41009e",
  null
  
)

export default component.exports